import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[awIsAuthenticated]'
})
export class IsAuthenticatedDirective implements OnInit, OnDestroy {

  private hasView = true;
  private showIfAuthenticated = true;

  constructor(
    private authService: AuthService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
  }

  @Input() set awIsAuthenticated(value: boolean) {
    this.showIfAuthenticated = value;
  }

  ngOnInit(): void {
    this.viewContainer.clear();
    this.hasView = false;
    this.authService.onUserChange()
      .subscribe((value) => {
        if (this.hasView && !value == this.showIfAuthenticated) {
          this.viewContainer.clear();
          this.hasView = false;
        } else if (!this.hasView && !!value == this.showIfAuthenticated) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        }
      });
  }

  ngOnDestroy(): void {
  }

}
